
import { defineComponent } from "vue";
import {
  productVisual,
  productVisualId,
  ProductVisual,
  ProductVisualId,
} from "./productVisuals";

export default defineComponent({
  name: "PackageIcon",
  props: {
    /**
     * El id del producto, en CUALQUIER vocabulario: nivel vivo (`gtr-fly`),
     * etiqueta retirada (`trading-academy`), doc-id de licencia
     * (`gtr-distributor-license`) o `none`. La traducción la hace
     * `productVisuals`, no cada llamante.
     */
    product: { type: String, default: undefined },
    /** Pinta el icono con el color del producto en vez de heredar el del texto. */
    colored: { type: Boolean, default: false },
    /** Clases extra (tamaño, márgenes) — mismo hueco que `RankIcon`. */
    extraClass: { type: String, default: "" },
    /**
     * Texto para lectores de pantalla. Sin él el icono es decorativo
     * (`aria-hidden`), que es lo correcto cuando el nombre del paquete ya
     * está escrito al lado.
     */
    label: { type: String, default: "" },
  },
  computed: {
    visualId(): ProductVisualId {
      return productVisualId(this.product);
    },
    visual(): ProductVisual {
      return productVisual(this.product);
    },
  },
});
